import React from 'react'
import MenuNav from '../../components/MenuNav'
import AddBoardCp from '../../components/AddBoardCp'

function AddBoard() {
  return (
    <div>
      <MenuNav />
      <AddBoardCp />
    </div>
  )
}

export default AddBoard
